import { atom } from 'recoil';
import InterventionOrder from '../../interfaces/api/InterventionOrder';

export default atom({
  key: 'interventionOrders',
  default: {} as { [key: string]: InterventionOrder },
});
